export default {
      id: "phone-usage",
      viewBox: "0 0 401.998 401.998",
      url: "../../assets/" + "sprite.svg#phone-usage",
      toString: function () {
        return this.url;
      }
    }